export default "__VITE_ASSET__CKqzylgJ__"